import { render, staticRenderFns } from "./reportB5.vue?vue&type=template&id=11aac5a2&"
import script from "./reportB5.vue?vue&type=script&lang=js&"
export * from "./reportB5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports